import { Component, OnInit } from '@angular/core';
import { EmployeePositionService } from '../../service/employee-position/employee-position.service';
import { EmployeePosition } from '../../class/employee-position';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-employee-positions',
  templateUrl: './employee-positions.component.html',
  styleUrls: ['./employee-positions.component.scss']
})
export class EmployeePositionsComponent implements OnInit {

    public promiseForm: Promise<any>;
    public msgs: Message[] = [];
    public employeePositions: EmployeePosition[];
    public selectEmployeePositions: EmployeePosition;
    public employeePositionsID: Number = 0;
    public modNew = false;
    public modView = false;
    public openEmployeePositions = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;

    constructor(
        public employeeService: EmployeePositionService,
        public confirmationService: ConfirmationService,
        public translate: TranslateService) { }

    ngOnInit() {
        //this.getEmployeePositions();
        this.page = 1;
        this.per_page = 100;
    }

    public loadEmployeePositionsLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            this.sort =  event.sortField;
        }
        this.getEmployeePositions(event.globalFilter);
    }

    public getEmployeePositions(query?: string) {
        this.employeeService.getEmployeePositions(this.page, this.per_page, this.sort, query).toPromise().then(
            response => {
                this.employeePositions = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newEmployeePositions() {
        this.modNew = !this.modNew;
        this.selectEmployeePositions = null;
    }

    public savedEmployeePositions(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectEmployeePositions = null;
        this.modNew = false;
        this.getEmployeePositions();
    }

    public cancelEmployeePositions (res) {
        this.selectEmployeePositions = null;
        this.modNew = false;
        this.modView = false;
        this.getEmployeePositions();
    }

    public edit(employeePositions: EmployeePosition) {
        this.modNew = true;
        this.selectEmployeePositions = employeePositions;
        this.getEmployeePositions();
    }

    public view(employeePositions: EmployeePosition) {
        this.openEmployeePositions = true;
        this.selectEmployeePositions = employeePositions;
        this.employeePositionsID = employeePositions.id;
        this.modView = true;
    }

    public deleteDialog(employeePositions: EmployeePosition) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(employeePositions);
            }
        });
    }

    public delete(employeePositions: EmployeePosition) {
        this.employeeService.deleteEmployeePositions(employeePositions.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getEmployeePositions();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeEmployeePositions(employeePositions: EmployeePosition) {
        this.putEmployeePositions(employeePositions);
    }

    public putEmployeePositions(values: EmployeePosition) {
        const param = {
            'activated': values.activated
        };
        if (values) {
            const promise = this.employeeService.updateEmployeePositions(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/employee-positions/employee-positions.component.ts